import React, { PropTypes } from 'react';
import classNames from 'classnames';
import { ContentStatus } from 'enums';
import WatchPropTypes from 'common/PropTypes';
import { isEmpty } from 'lib/util';

const SuperHero = ({ name, description, director, image, logoImage, subtitle, content, clickHandler: clickHandlerArg }) => {
    // TODO: DTC - Temp solution. Fields shouldn't come without escaped values from the PageAPI
    const heroEvent = (subtitle) ? subtitle.replace(/\\u2022/g, '•') : '';
    const clickHandler = !isEmpty(content) && clickHandlerArg;
    const playButtonClasses = classNames('button-play', 'button-play--video', {
        'button-play--live': (!isEmpty(content) && content.status === ContentStatus.LIVE)
    });
    return (
        <article className="hero--super hero--dtc">
            <figure className="hero_wrapper">
                {clickHandler ? (
                    <a className="col-a" onClick={clickHandler}>
                        <picture>
                            <img className="hero_img" src={image} alt={name} />
                        </picture>
                        <div className={playButtonClasses} />
                    </a>
                ) : (
                    <span className="col-a">
                        <picture>
                            <img className="hero_img" src={image} alt={name} />
                        </picture>
                    </span>
                )}
            </figure>
            <figcaption className="dtc_hero__detail">
                {logoImage && (
                    <div className="dtc_hero__logo">
                        <img className="dtc_hero__logo__img" src={logoImage} alt={name} />
                    </div>
                )}
                <div className="dtc_hero__meta">
                    <div className="dtc_hero__truncate">
                        <span className="dtc_hero__event">{heroEvent}</span>
                    </div>
                </div>
                <div className="dtc_hero__title">{name}</div>
                <div className="dtc_hero__description">
                    {description}
                </div>
                <div className="dtc_hero__author">
                    {director}
                </div>
            </figcaption>
        </article>
    );
};

SuperHero.propTypes = {
    name: PropTypes.string,
    description: PropTypes.string,
    director: PropTypes.string,
    image: PropTypes.string,
    logoImage: PropTypes.string,
    subtitle: PropTypes.string,
    content: WatchPropTypes.content,
    clickHandler: PropTypes.func
};

export default SuperHero;



// WEBPACK FOOTER //
// ./app/common/page/hero/SuperHero/index.js